export default __webpack_public_path__ + "static/dresses-results-4-a8d15b16fab56a1244ed70fd8991fdf4.png";